<template>
    <div>
        <headerNotice routerName="促销设置"></headerNotice>
        <el-form :loading="loading" class="from-el">
            <el-form-item :rules="{required: true}" label="满减活动标签:" label-width="138px">
                <el-input
                    placeholder="满减"
                    class="input-el"
                    v-model="tagName1"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="满赠活动标签:" label-width="138px">
                <el-input
                    placeholder="满赠"
                    class="input-el"
                    v-model="tagName2"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="限时折扣活动标签:" label-width="138px">
                <el-input
                    placeholder="促销"
                    class="input-el"
                    v-model="tagName3"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item :rules="{required: true}" label="秒杀活动标签:" label-width="138px">
                <el-input
                    placeholder="秒杀"
                    class="input-el"
                    v-model="tagName4"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-button type="primary" :loading="btnLoading" @click="setDatas">提交</el-button>
        </el-form>
    </div>
</template>
<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
    components: {
        headerNotice
    },
    props: {},
    data() {
        return {
            btnLoading: false,
            loading: true,
            tagName1: "",
            tagName2: "",
            tagName3: "",
            tagName4: ""
        }
    },
    watch: {},
    computed: {},
    mounted() {
        this.getDatas();
    },
    methods: {
        //获取数据
        getDatas() {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminPromotionTag/GetList",
                success(res) {
                    self.loading = false;
                    if (res) {
                        self.tagName1 = res[0].tagName;
                        self.tagName2 = res[1].tagName;
                        self.tagName3 = res[2].tagName;
                        self.tagName4 = res[3].tagName;
                    }
                },
                fail(res) {
                    self.loading = false;
                }
            });
        },
        // 提交数据
        setDatas() {
            let self = this;
            let params = [
                {tagName:self.tagName1, promotionType: 1},
                {tagName:self.tagName2, promotionType: 2},
                {tagName:self.tagName3, promotionType: 3},
                {tagName:self.tagName4, promotionType: 4}
            ]
            self.btnLoading = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminPromotionTag/Set",
                data: params,
                success(res) {
                    self.$message({
                        message: "添加成功",
                        type: "success"
                    });
                    self.btnLoading = false;
                },
                fail(res) {
                    self.$message({
                        message: "添加失败",
                        type: "success"
                    });
                    self.btnLoading = false;
                }
            });
        }
    },
    created() {}
}
</script>
<style lang="scss" scoped>
.el-form{
    width: 40%;
    margin: 50px auto;
    display: block;
    .el-button{
        margin: 0 auto;
        display: block;
    }
}
</style>
